import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import TutorialSliderIntro from "../../components/TutorialSliderIntro";
import ReactPlayer from "react-player";

const Tutorial = () => {
  const navigate = useNavigate();
  const bgNarration = useRef(null);

  useEffect(() => {
    getColors();
    getVideos();
    startBackgroundNarrationAudio();
  }, []);

  const [playVideo, setPlayVideo] = React.useState(false);
  const [introVideoUrl, setIntroVideo] = useState("");

  const getColors = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API + "Colors/getColors"
      );
      document.documentElement.style.setProperty(
        "--primary-color",
        response.data.primaryColor
      );
      document.documentElement.style.setProperty(
        "--secondary-color",
        response.data.secondaryColor
      );
    } catch (error) {
      console.error(error);
      console.log("There was an error!", error);
    }
  };

  const getVideos = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API + "Videos/getVideos"
      );
      setIntroVideo(response.data.introVideo);
    } catch (error) {
      console.error(error);
      console.log("There was an error!", error);
    }
  };

  const videoReady = () => {
    setPlayVideo(true);
  };

  const endSliderClick = () => {
    const clickAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777458839/TUTORIAL_SKIP_lpxcqo.mp3");
    clickAudio.volume = 1;
    clickAudio.play().catch((err) => {
      console.log(err);
    });
    stopAllAudio();
    localStorage.setItem("seenTutorial", "1");
    navigate("/video");
  };

  const startBackgroundNarrationAudio = () => {
    if (!bgNarration.current) {
      const audio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777370841/1_Intro_Musiconly_Master_seqyym.mp3");
      audio.loop = true;
      audio.volume = 0.1;
      bgNarration.current = audio;
    }

    bgNarration.current.play().catch((err) => {
      console.log("BG AUDIO BLOCKED:", err);
    });
  };

  const stopAllAudio = () => {
    if (bgNarration.current) {
      bgNarration.current.pause();
      bgNarration.current.currentTime = 0;
    }
  };

  return (
    <div className="video-page-container">
      {!playVideo && <div className="loading-black-bg"></div>}
      <div className="video-bg">
        <ReactPlayer
          className="video-container"
          url={introVideoUrl}
          loop={true}
          playing={playVideo}
          muted={true}
          controls={false}
          playsinline={true}
          onReady={() => videoReady()}
        />
        <div className="tutorial-bg">
          <div className="tutorial-backdrop">
            <div className="tutorial-dialog-container">
              <IconButton
                className="tutorial-close-icon"
                onClick={endSliderClick}
              >
                <CloseIcon />
              </IconButton>
              <TutorialSliderIntro onSliderEndClick={endSliderClick} />
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default Tutorial;
